module.exports = {"id":"223794","name":"Philipp Schobesberger","rating":"72","photo":"./data/images/photos/1/223794.png","club":{"name":"SK Rapid Vienne","logo":"./data/images/clubs/SKRapidVienne.png"},"positions":["AD","MD","ATT"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PhilippSchobesberger0.json
// module id = 3456
// module chunks = 0